<template>
  <esg-base-dashboard-card title="에너지 사용량"
                           :subtitle="`(${corporation.name} - 에너지원 단위 - 과거 3개년 )`">
    <template #actions>
      <b-row>
        <b-col cols="auto">
          <esg-base-select-box label="법인"
                               v-model="corporationCode"
                               :options="corporations"/>
        </b-col>
        <!-- 23-10-11 윤지원: 문경태 팀장님의 요청에 의해 정렬 기능 삭제 -->
<!--        <b-col cols="auto">-->
<!--          <esg-base-select-box v-model="sort"-->
<!--                               label="정렬">-->
<!--            <option value="asc">오름차순</option>-->
<!--            <option value="desc">내림차순</option>-->
<!--          </esg-base-select-box>-->
<!--        </b-col>-->
      </b-row>
    </template>
    <b-row>
      <b-col>
        <energy-by-fuel-for-corp :corporation="corporation"
                                 :sort="sort"/>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <template v-for="(businessLocation, idx) in businessLocations">
        <b-col lg="4"
               :key="businessLocation.business_location_code">
          <energy-by-fuel-for-biz-loc :business-location="businessLocation"
                                      :colors="colors.slice(idx, idx + 1)"
                                      :sort="sort"/>
        </b-col>
      </template>
    </b-row>
  </esg-base-dashboard-card>

</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EnergyByFuelForCorp from "../charts2/CorpEnergyByFuel.vue";
import EnergyByFuelForBizLoc from "../charts2/BizLocEnergyByFuel.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: 'EnterpriseConsumptionByEnergy',
  components: {EsgBaseSelectBox, EnergyByFuelForCorp, EsgBaseDashboardCard, EnergyByFuelForBizLoc},
  data() {
    return {
      corporationCode: '',
      corporations: [],
      businessLocations: [],
      sort: 'desc',
    }
  },
  computed: {
    corporation() {
      if (!this.corporationCode)
        return {}
      return this.corporations.find(corp => corp.code === this.corporationCode);
    },
    colors() {
      return this.$store.getters['ghg/colors'];
    }
  },
  watch: {
    corporation: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchBusinessLocations();
      }
    }
  },
  created() {
    this.fetchCorps();
  },
  methods: {
    async fetchCorps() {
      try {
        let response = await axios.get('esg/lca/tables/esg_base_corporation', {
          headers: {Authorization: accessToken()}
        });

        // Add value and text to use data as select options
        response.data.list.forEach(corp => {
          corp.value = corp.code;
          corp.text = corp.name;
        });

        this.corporations = response.data.list;

        // Set default
        this.corporationCode = this.corporations[0].code;
      } catch (error) {
        await this.showError(error);
      }
    },
    async fetchBusinessLocations() {
      if (!this.corporation.code) return;

      try {
        let response = await axios.get('esg/lca/business-location', {
          headers: {Authorization: accessToken()},
          params: {
            filters: [
              {
                name: 'esg_base_corporation.tenant_id',
                value: this.tenantId(),
                operation: 'EQUAL'
              },
              {
                name: 'esg_base_corporation.code',
                value: this.corporation.code,
                operation: 'EQUAL'
              }
            ]
          }
        });
        this.businessLocations = response.data.list;
      } catch (error) {
        await this.showError(error);
      }
    },
  }
}
</script>
<style scoped>
>>> {
  font-family: NanumGothic;
}
</style>